

export const DIAGRAMS = {
    EMAILS: {
        RECEIVED: 'received',
        SUGGESTED: 'suggested',
        SENT: 'sent'
    },
    TOKENS: {
        MONTHLY: 'monthly',
        DAILY: 'daily'
    }
}